import React from 'react';

export function LoadingIndicator() {
    return (
        <span className="loader" role="status"></span>
  );
}